import React, { useState, useImperativeHandle } from 'react';
import { Form, Row, Col, Button, Upload, Tooltip, Space } from 'antd';
import { DeleteOutlined, CheckOutlined, PlusOutlined } from '@ant-design/icons';
import { v4 as uuidv4 } from 'uuid';

import global from '../../../../shared/utility/global';

function FormImage(props, ref) {
    const [files, setFiles] = useState([]);

    useImperativeHandle(ref, () => ({
        onFetchFiles: () => {
            return [...files.map(m => ({ ...m, name: m.name }))];
        },
        onLoad: (_files) => {
            setFiles(_files.map(m => ({ ...m, uid: uuidv4() })));
        }
    }));

    const onBefore = async (file) => {
        file.stringBase64 = await global.getBase64(file);
        file.blob = new Blob([file], { type: file.type });
        file.index = files.length + 1;
        file.storageFilename = uuidv4() + '.' + file.name.split('.')[file.name.split('.').length - 1];
        setFiles(collection => {
            file.isMain = collection.length === 0 ? true : false;
            return [...collection, file];
        });
        return false;
    };

    const onRemove = (uid) => {
        var file = files.find(m => m.uid === uid);
        if (file !== undefined) {
            const index = files.indexOf(file);
            const newFiles = files.slice();
            newFiles.splice(index, 1);
            newFiles.forEach((item, index) => {
                item.index = index + 1;
            });

            if (newFiles.filter(m => m.isMain).length === 0 && newFiles.length > 0)
                newFiles[0].isMain = true;

            setFiles(newFiles);
        }
    };

    const onMainImage = (item) => {
        var images = files.map(m => m);
        images.forEach(m => {
            m.isMain = false;
            if (m.uid === item.uid)
                m.isMain = true;
        });
        setFiles(images);
    };

    return (
        <>
            <Row gutter={15} className="mt-10">
                <Col xs={24} sm={20} md={17} lg={12} xl={11} xxl={10}>
                    <Form.Item label="">
                        <Upload
                            showUploadList={false}
                            multiple={true}
                            beforeUpload={onBefore}
                        >
                            <Button icon={<PlusOutlined />}>
                                Imagenes
                            </Button>
                        </Upload>
                    </Form.Item>
                </Col>
            </Row>
            <Row style={{ margin: '0px -10px 0px -10px' }}>
                {
                    files.map(item => (
                        <Col key={item.uid} xs={24} sm={24} md={12} >
                            <div style={{ padding: '10px' }}>
                                <div className='catalog-card-content'>
                                    <div className='catalog-card-item'>
                                        <div className="vertical-center h-100">
                                            <img src={item.stringBase64 ?? item.imageMedium} alt="card" />
                                        </div>
                                    </div>
                                    <div className='catalog-card-info'>
                                        <div className="flex-parent">
                                            <div className="flex-child long-and-truncated">
                                                <div className='ml-5'>
                                                    <Tooltip title={item.name}>
                                                        <div className='catalog-card-title'>{item.name}</div>
                                                    </Tooltip>
                                                </div>
                                            </div>
                                            <div className="flex-child short-and-fixed">
                                                <Tooltip title='Eliminar'>
                                                    <Button danger
                                                        type="text"
                                                        style={{ paddingTop: '6px' }}
                                                        icon={<DeleteOutlined style={{ fontSize: '18px' }} />}
                                                        onClick={() => onRemove(item.uid)}
                                                    />
                                                </Tooltip>
                                            </div>
                                        </div>

                                        <div className='catalog-card-check'>
                                            <Tooltip title='Establecer como imagen principal'>
                                                <Button
                                                    type={item.isMain ? 'success' : 'default'}
                                                    icon={<CheckOutlined />}
                                                    size="middle"
                                                    shape="circle"
                                                    style={{ paddingTop: 5 }}
                                                    onClick={() => onMainImage(item)}
                                                />
                                            </Tooltip>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Col>
                    ))
                }
            </Row>
        </>
    );
}
export default React.forwardRef(FormImage);